var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBackWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.43623 14.9283L8.62285 15.7417C8.27845 16.0861 7.72155 16.0861 7.38081 15.7417L0.258301 8.62285C-0.0861003 8.27845 -0.0861003 7.72155 0.258301 7.38081L7.38081 0.258301C7.72521 -0.0861003 8.28212 -0.0861003 8.62285 0.258301L9.43623 1.07167C9.78429 1.41974 9.77696 1.98763 9.42157 2.32837L5.00664 6.53446H15.5365C16.0238 6.53446 16.4158 6.92649 16.4158 7.41379V8.58622C16.4158 9.07351 16.0238 9.46554 15.5365 9.46554H5.00664L9.42157 13.6716C9.78063 14.0124 9.78795 14.5803 9.43623 14.9283Z",
    fill: "#F0EAD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackWhite);
export default __webpack_public_path__ + "static/media/ArrowBackWhite.3b983690a696c46aecda29abed1f143f.svg";
export { ForwardRef as ReactComponent };